module.exports = "<img [src]=\"imagePath\" [alt]=\"imageAlt\" [ngStyle]=\"style\" [ngClass]=\"cssClass\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/logo-operadora/logo-operadora.component.html
// module id = ./src/app/common/logo-operadora/logo-operadora.component.html
// module chunks = main